import { useTranslation } from "react-i18next";
import { Storage as StorageFeature } from "@/partner/features/storage";
import { Meta } from "@/shared/components";

export function StoragePage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("storage.pageTitle")} pageType="Partner" />
      <StorageFeature />
    </>
  );
}
